<template>
  <LayoutDefault>
    <div
      class="container dark"
      id="change_username"
    >
      <section class="block" v-if="sendingLoading">
        <div class="container spinner" >
          <Spinner />
        </div>
      </section>
      <section class="block" style="padding: 3rem 0;" v-if="!sendingLoading">
        <h1>{{$t('change_username.title')}}</h1>
        <div v-if="success">
          <p class="success-message">
            {{$t('change_username.success')}}
          </p>
        </div>
        <div>
          <p>
            {{$t('change_username.text_current_username')}} {{username}}
          </p>
        </div>
        <div v-if="canUpdate">
          <p>
          {{$t('change_username.input_new_username')}} <input type="text" v-model="changeUsernameForm.username" />
        </p>
          <template v-if="$v.changeUsernameForm.username.$error">
            <p
              class="error-message"
              v-if="!$v.changeUsernameForm.username.required"
            >
              {{$t('validations.required', {field: $t('fields.username')})}}
            </p>
          </template>
          <template v-if="errorMessage">
            <p
              class="error-message"
            >
              {{errorMessage}}
            </p>
          </template>
        </div>
        <div v-if="canUpdate">
          <button class="change_username_button" @click="changeUsername">{{$t('change_username.button')}}</button>
        </div>
      </section>
      <section class="block" style="display:flex;align-content: space-between;align-items: center;margin: 1rem auto;">
          <div style="flex:1;">
            <router-link
              class="support-link"
              :to="{name: 'support'}">
              {{ $t('zammad_support.link') }}
            </router-link>
          </div>
          <div>
            <a    
              @click="goBackOrHome" class="btn-go-back">&laquo; 
              {{ $t('dashboard.back') }}
            </a>
          </div>
        </section>
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Spinner from "../components/Spinner";
import { required, minLength, minValue, maxLength, maxValue } from 'vuelidate/lib/validators';
import resources from "../resources";

export default {
  components: {
    LayoutDefault,
    Spinner
  },
  data() {
    return {
      sendingLoading: false,
      username: '',
      changeUsernameForm: {
        username: ''
      },
      errorMessage: '',
      success: false
    };
  },
  computed:{
    canUpdate(){
      return !this.success && !this.$auth.user().username_updated
    } 
  },
  methods: {
    changeUsername() {
      if (this.$v.changeUsernameForm.$invalid) {
        return this.$v.changeUsernameForm.$touch();
      }
      this.sendingLoading = true;
      this.success = false;
      this.changeUsernameForm.username = this.changeUsernameForm.username.toLowerCase();
      resources.chatChangeUsername.store({username: this.changeUsernameForm.username})
        .then(data => {
          this.username = this.changeUsernameForm.username;
          this.success = true;
          this.errorMessage = '';
          this.sendingLoading = false;
          this.$auth.user().username = this.username;
          this.$auth.user().username_updated = true;
        }).catch((err) => {
          this.errorMessage = err.body.message;
          this.sendingLoading = false;
        });
      // let readBaseUrl = process.env.VUE_APP_ROOT_API.replace(/\/+$/, "");
      // this.$http.post(readBaseUrl+'/chat/change_username', {username: this.changeUsernameForm.username})
      //       .then(data => {
      //         this.username = this.changeUsernameForm.username;
      //         this.success = true;
      //         this.errorMessage = '';
      //         this.sendingLoading = false;
      //         this.$auth.user().username = this.username;
      //       }).catch((err) => {
      //         this.errorMessage = err.body.message;
      //         this.sendingLoading = false;
      //       });
    },
    goBackOrHome() {
      if (this.$route.meta.previousRoute) {
        // Si hay una ruta anterior almacenada, redirigimos a ella
        this.$router.push(this.$route.meta.previousRoute);
      } else {
        // Si no hay una ruta anterior almacenada, redirigimos al home
        this.$router.push({ name: "home" });
      }
    },
  },
  validations() {
    return {
      changeUsernameForm: {
        username: {
          required
        }
      }
    };
  },
  mounted() {
    if(this.$auth.user().username_updated){
      this.$router.push({name: 'home'});
    }
    if (this.$auth.user().username!='') {
      this.username = this.$auth.user().username;
    }
  }
}
</script>
<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/classes';

#change_username {
  box-sizing: border-box;
  min-height: 500px;
  padding: 9px;


  & .spinner {
    align-items: center;
    display: flex;
    min-width: 300px;
    min-height: 300px;      
    justify-content: center;
  }
}

.change_username_button {
  box-sizing: border-box;
  background-color: var(--pallete_main_color);
  color: white;
  padding: 0.5rem;
  margin: 1rem 0 0.5rem 0;
}

.block {
  margin:0 auto;
  width: 75%;
  & .success-message {
    color: green;
    font-size: 1rem;
  }

  & .error-message {
    color: var(--pallete_main_color);
    font-size: 0.9rem;
    padding: 0.3rem;
  }
}

.support-link {
  &:hover {
    font-weight: bold;
  }
}

.btn-go-back {
  color: var(--pallete_main_color);
  &:hover {
    cursor: pointer;
    font-weight: bold;
  }
}
</style>